export const DEALERS_PARAM_FETCH_FIELD_VALUE = {
  DONE: 'done',
  PENDING: 'pending',
  WAIT: 'wait',
};

export const DEALERS_PARAMS_FIELDS = {
  DEALER_ID: 'dealerId',
  FETCH_DEALERS_PARAMS: 'fetchDealersParams',
  NEW_CARS: 'newCars',
  USED_CARS: 'usedCars',
};

export const STORE_FIELDS = {
  CAR_INFO_FETCH: 'carInfoFetch',
  CAR_INSTANCE: 'carInstance',
  DEALERS_PARAMS: 'dealersParams',
  DECLINE_DROP_ERRORS: 'declineDropErrors',
  DISABLE_FIELDS: 'disableFields',
  ERROR: 'error',
  ERRORS: 'errors',
  FETCH: 'fetch',
  HIDDEN_FIELDS: 'hiddenFields',
  IS_COLLAPSABLE: 'isCollapsable',
  IS_DISABLE: 'isDisable',
  IS_OPEN_BLOCK: 'isOpenBlock',
  IS_OPEN_DETAILS: 'isOpenDetails',
  IS_PATCHING: 'isPatching',
  PATCH_IS_NEW: 'patchIsNew',
  REQUIRED_FIELDS: 'requiredFields',
  SCROLL_TO: 'scrollTo',
};

export const CONTRACT_VALUE_FIELDS = {
  DATE: 'contractDate',
  NUMBER: 'number',
};

export const DIAGNOSTIC_CARD_VALUE_FIELDS = {
  BEGIN_DATE: 'beginDate',
  END_DATE: 'endDate',
  NUMBER: 'number',
};

export const DISCOUNT_TYPE_VALUES = {
  MFR: 'mfr',
  DIRECT: 'direct',
};

export const INVOICE_VALUE_FIELDS = {
  DATE: 'date',
  NUMBER: 'number',
};

export const PTS_VALUE_FIELDS = {
  ISSUE_DATE: 'issueDate',
  NUMBER: 'number',
  SERIES: 'series',
  STATUS: 'status',
};

export const STEERING_WHEEL_VALUES = {
  LEFT: 'left',
  RIGHT: 'right',
};

/** Поля которые проставляет фронт в ответ ручки "/api/car-instance/<id>" */
export const FRONT_VALUE_FIELDS = {
  ACCOUNT_NUMBER: 'accountNumber',
  BANK_NAME: 'bankName',
  BIC: 'bic',
  CATALOG_BLOCK: 'catalogBlock',
  CONTRACT: 'contract',
  IMAGE: 'image',
  INN: 'inn',
  INVOICE: 'invoice',
  NDS_AMOUNT: 'ndsAmount',
  NDS_FLAG: 'ndsFlag',
  RECIPIENT: 'recipient',
};

export const VALUE_FIELDS = {
  ...FRONT_VALUE_FIELDS,
  BODY_NUMBER: 'bodyNumber',
  BRAND: 'brand',
  CAR_ISSUE_DATE: 'carIssueDate',
  COLOR_TEXT: 'colorText',
  DEFAULT_PRICE: 'defaultPrice',
  DIAGNOSTIC_CARD: 'diagnosticCard',
  DISCOUNT_TYPE: 'discountType',
  ENGINE_NUMBER: 'engineNumber',
  ENGINE_POWER: 'enginePower',
  ENGINE_VOLUME: 'engineVolume',
  GLONAS_NUMBER: 'glonasNumber',
  ID: 'id',
  IS_NEW: 'isNew',
  MILEAGE: 'mileage',
  MODEL: 'model',
  OFFER_PRICE: 'offerPrice',
  PERMITTED_MAX_WEIGHT: 'permittedMaxWeight',
  PRICE: 'price',
  PTS: 'pts',
  REGISTRATION_NUMBER: 'registrationNumber',
  STEERING_WHEEL: 'steeringWheel',
  VERSION: 'version',
  VIN: 'vin',
  YEAR: 'year',
};
